import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    makeStyles,
    Typography,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import API from "../../middleware/Api";
import { useLocation } from "react-router";
import {
    toggleSnackbar,
} from "../../redux/explorer";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
    layout: {
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.palette.background.default,
    },
    box: {
        width: 400,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: theme.spacing(4),
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius,
        boxShadow: theme.shadows[3],
    },
    favicon: {
        height: 60,
        marginBottom: theme.spacing(3),
    },
    welcomeText: {
        fontSize: "1.5rem",
        fontWeight: 500,
        color: theme.palette.text.primary,
        marginBottom: theme.spacing(3),
        textAlign: "center",
    },
    loginButton: {
        width: "80%",
        padding: theme.spacing(1.5, 0),
        fontSize: "1rem",
        borderRadius: theme.shape.borderRadius,
    },
    errorText: {
        marginBottom: theme.spacing(2),
        textAlign: "center",
    },
}));

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function LoginForm() {
    const [loading, setLoading] = useState(false);

    const classes = useStyles();
    const { t } = useTranslation("common");
    const history = useHistory();
    const query = useQuery();
    const oauthError = query.get("oauth_error");

    useEffect(() => {
        localStorage.removeItem("siteConfigCache");
    }, []);

    const startOAuth = () => {
        setLoading(true);
        API.get("/user/oauth")
            .then((res) => {
                // 跳转到认证服务器授权页（state 已由后端写入会话）
                window.location.href = res.data;
            })
            .catch((error) => {
                setLoading(false);
                toggleSnackbar("top", "right", error.message, "error");
            });
    };

    return (
        <div className={classes.layout}>
            <Box className={classes.box}>
                <img 
                    src="/static/img/logo192.png" 
                    alt="NoOA Cloud" 
                    className={classes.favicon}
                />
                <Typography className={classes.welcomeText}>
                    Welcome to NoOA Cloud!
                </Typography>
                {oauthError && (
                    <Typography
                        color="error"
                        variant="body2"
                        className={classes.errorText}
                    >
                        OAuth 登录失败，请重试。
                    </Typography>
                )}
                <Button
                    variant="contained"
                    color="primary"
                    className={classes.loginButton}
                    onClick={startOAuth}
                    disabled={loading}
                >
                    {loading ? t("processing") : "Login w/ NoOA OAuth"}
                </Button>
            </Box>
        </div>
    );
}

export default LoginForm;
